/**
 * A list of touch devices by category, for UA parsing.
 * @type {String[]}
 */
export const TOUCH_DEVICES = ['mobile', 'tablet'];
